import type {
  RawData,
  TestDefinition,
  TestResult,
  ValidationResult,
} from '../types.ts';
import {
  errorText,
  formatHash,
  formatError,
  result,
  validation,
  validationError,
} from './shared.ts';

async function collect(): Promise<RawData> {
  const element = document.createElement('button');
  element.textContent = 'ABC';
  document.body.append(element);
  const style = getComputedStyle(element);
  const scroll = document.createElement('div');
  scroll.style.cssText =
    'width:100px;height:100px;overflow:scroll;position:fixed;visibility:hidden';
  document.body.append(scroll);
  try {
    return {
      systemColors: {
        canvas: CSS.supports('color', 'CanvasText')
          ? 'supported'
          : 'unsupported',
        accent: CSS.supports('color', 'AccentColor')
          ? 'supported'
          : 'unsupported',
      },
      formControls: {
        button: {
          display: style.display,
          fontFamily: style.fontFamily,
          fontSize: style.fontSize,
          borderStyle: style.borderStyle,
          borderRadius: style.borderRadius,
        },
      },
      scrollbar: {
        width: scroll.offsetWidth - scroll.clientWidth,
        height: scroll.offsetHeight - scroll.clientHeight,
      },
      mediaQueries: {
        dark: matchMedia('(prefers-color-scheme: dark)').matches,
        reducedMotion: matchMedia('(prefers-reduced-motion: reduce)').matches,
        forcedColors: matchMedia('(forced-colors: active)').matches,
        hover: matchMedia('(hover: hover)').matches,
        finePointer: matchMedia('(pointer: fine)').matches,
      },
    };
  } finally {
    element.remove();
    scroll.remove();
  }
}

function format(rawData: RawData): string {
  const error = formatError(rawData);
  if (error) {
    return error;
  }
  return formatHash(rawData);
}

async function run(): Promise<TestResult> {
  let rawData: RawData;
  try {
    rawData = await collect();
  } catch (error) {
    rawData = { error: errorText(error) };
  }
  return result(rawData, format);
}

function validate(rawData: RawData): ValidationResult {
  const error = validationError(rawData);
  if (error) {
    return error;
  }
  return validation([]);
}

export const cssSystemTest: TestDefinition = {
  id: 'windowsCssAppearance',
  title: 'Windows CSS appearance',
  category: 'shared',
  format,
  run,
  validate,
};
